import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  noop,
} from 'lodash';
import OutsideClickHandler from 'react-outside-click-handler';
import TextField from '@material-ui/core/TextField';

import { DropdownItems } from 'components';

export class AutoFill extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })).isRequired,
    label: PropTypes.string,
    loading: PropTypes.bool,
    placeHolder: PropTypes.string,
    absolute: PropTypes.bool,
    value: PropTypes.string,

    onTextChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
    optionRenderer: PropTypes.func.isRequired,
  };

  static defaultProps = {
    absolute: false,
    label: '',
    loading: false,
    placeHolder: '',
    value: '',
    onSelect: noop,
  };

  state = {
    showItems: false,
  };

  getOptions = () => {
    const { items, optionRenderer } = this.props;
    const { showItems } = this.state;

    if (!showItems) {
      return [];
    }

    return items.map(item => ({
      id: item.id,
      primaryText: optionRenderer(item),
      onClick: () => this.handleSelect(item),
    }));
  }

  handleBlur = () => {
    setTimeout(() => {
      this.setState({ showItems: false });
    }, 500);
  }

  handleFocus = () => {
    this.setState({ showItems: true });
  }

  handleSelect = (item) => {
    const { onSelect } = this.props;

    onSelect(item);
    this.setState({ showItems: false });
  }

  render() {
    const {
      label,
      loading,
      value,
      onTextChange,
      placeHolder,
      absolute,
    } = this.props;

    const searchedItems = (
      <DropdownItems
        loading={loading}
        absolute={absolute}
        options={this.getOptions()}
      />
    );

    return (
      <div className="auto-fill">
        <OutsideClickHandler onOutsideClick={this.handleBlur}>
          <TextField
            autoComplete="off"
            fullWidth
            label={label}
            onChange={ev => onTextChange(ev.target.value)}
            onClick={this.handleFocus}
            onFocus={this.handleFocus}
            placeholder={placeHolder}
            value={value}
            variant="outlined"
          />
          {searchedItems}
        </OutsideClickHandler>
      </div>
    );
  }
}

export default AutoFill;
